<template>
  <layout title="Über uns" :banner="$page.props.banner" h1="Über uns" metaDescription="Bereits seit über 30 Jahren sind wir auf die schönsten Skigebiete Österreichs und Italiens spezialisiert. Wir bieten euch Top Unterkünfte in Toplagen. Jetzt buchen!" metaKeywords="SCOL, Über SCOL, SCOL Skireisen, Skireise, Skireise buchen, Team SCOL">
    <section id="ueber-uns-content">
      <div class="scol-section bg-light">
        <div class="container-fluid">
          <div class="text-center">
            <h2 class="text-secondary">
              Wintersport ist mehr als ein Hobby,<br />es ist eine Leidenschaft.
            </h2>
          </div>
        </div>
        <div class="container-small text-block mt-5">
          <div class="row gx-5 m-0">
            <div class="col-md-6">
              <p>
                Bereits seit über 30 Jahren sind wir auf die schönsten
                Skigebiete Österreichs und Italiens spezialisiert. Deshalb
                können wir euch Unterkünfte in Toplagen anbieten, die jedem
                Anspruch genügen. Viele unserer Häuser befinden sich direkt im
                Ort und trotzdem in unmittelbarer Nähe zu Pisten und Bergbahnen.
                Kaum ein zweiter Veranstalter bietet euch so zentral gelegene
                Häuser, an so begehrten Lagen.
              </p>
              <p>
                Unsere Häuser bieten euch nicht nur Komfort, besten Service und
                Gemütlichkeit. Sie ermöglichen es euch euren Skiurlaub ganz nach
                euren Bedürfnissen zu gestalten. Ob es direkt auf die Piste oder
                auf eine Wanderung geht, in die Stadt auf Shopping-Tour, auf ein
                Event, in eine Ausstellung oder auf ein Konzert. Ihr befindet
                euch mittendrin und habt die Wahl, ganz entspannt zu
                entscheiden, wie euer Urlaubstag aussehen soll.
              </p>
              <p>
                Als Familie, Kleingruppe, Single oder zu zweit: Wer offen für
                neue Leute, nette Bekanntschaften oder sogar Freundschaften ist,
                lernt hier bestimmt tolle Menschen kennen.
              </p>
            </div>
            <div class="col-md-6">
              <p>
                Denn wer mit uns fährt, reist individuell aber nicht allein. Das
                macht es einfach sich anderen Leuten anzuschließen, wenn man es
                möchte. Aber nichts muss.
              </p>
              <p>
                Euer Winterurlaub soll Spaß machen. Egal ob ihr die Piste hoch-
                und runterfahrt, ein leckeres Essen genießt, in geselliger
                Runde den Abend verbringt, kulturelle Unterhaltung oder
                Erholung sowie Wellness für Körper und Seele sucht.
              </p>
              <p>
                Scol Reisen bietet alles was euer Skiurlaub unvergesslich macht.
                Und wenn ihr noch nie im Skiurlaub gewesen sein solltet, fragt
                uns gerne. Angefangen vom Skipass über die Empfehlung von
                Skischulen bis hin zur Besorgung der Leihausrüstung, beraten wir
                euch gerne und verraten euch, welche Pisten für euch geeignet
                sind. Wir kennen uns aus und lassen euch nicht allein.
              </p>
              <p>
                <b>SCOL Reisen - damit ihr mehr von eurem Winterurlaub habt.</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white position-relative scol-section" id="team">
        <div class="scol-section-caption">
          <h2>Das Büroteam</h2>
        </div>
        <div class="container py-4">
          <div class="row justify-content-center">
            <div class="col-sm-10 col-md-6 col-xl-4 mb-4">
              <div class="team-inner">
                <div class="person-image">
                  <img
                    class="rounded-circle border border-light border-3"
                    src="/images/team/ralf-kempermann.jpg"
                    alt="Ralf Kempermann"
                  />
                </div>
                <div class="person-info">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fas fa-user"></i>
                    <h3>Ralf Kempermann</h3>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-suitcase"></i>
                    <p>Geschäftsführer</p>
                  </div>
                  <!-- <div class="d-flex align-items-center">
                    <i class="fas fa-envelope"></i>
                    <a href="mailto:ralf@scol.de">ralf@scol.de</a>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 col-xl-4 mb-4">
              <div class="team-inner">
                <div class="person-image">
                  <img
                    class="rounded-circle border border-light border-3"
                    src="/images/team/simon-koronowski.jpg"
                    alt="Simon Koronowski"
                  />
                </div>

                <div class="person-info">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fas fa-user"></i>
                    <h3>Simon Koronowski</h3>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-phone-alt"></i>
                    <p>
                      <a href="tel:+494435960000">Tel. 04435 / 9600 - 00</a>
                    </p>
                  </div>
                  <!-- <div class="d-flex align-items-center">
                    <i class="fas fa-envelope"></i>
                    <p><a href="mailto:simon@scol.de">simon@scol.de</a></p>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 col-xl-4 mb-4">
              <div class="team-inner">
                <div class="person-image">
                  <img
                    class="rounded-circle border border-light border-3"
                    src="/images/team/diane-brueggemann.jpg"
                    alt="Diane Brüggemann"
                  />
                </div>

                <div class="person-info">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fas fa-user"></i>
                    <h3>Diane Brüggemann</h3>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-phone-alt"></i>
                    <p>
                      <a href="tel:+494435960000">Tel. 04435 / 9600 - 00</a>
                    </p>
                  </div>
                  <!-- <div class="d-flex align-items-center">
                    <i class="fas fa-envelope"></i>
                    <p><a href="mailto:diane@scol.de">diane@scol.de</a></p>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 col-xl-4 mb-4">
              <div class="team-inner">
                <div class="person-image">
                  <img
                    class="rounded-circle border border-light border-3"
                    src="/images/team/antje-fink-wieland.jpg"
                    alt="Antje Fink-Wieland"
                  />
                </div>

                <div class="person-info">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fas fa-user"></i>
                    <h3>Antje Fink-Wieland</h3>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-phone-alt"></i>
                    <p>
                      <a href="tel:+494435960000">Tel. 04435 / 9600 - 00</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 col-xl-4 mb-4">
              <div class="team-inner">
                <div class="person-image">
                  <img
                    class="rounded-circle border border-light border-3"
                    src="/images/team/tonia-deutschler.jpg"
                    alt="Tonia Deutschler"
                  />
                </div>

                <div class="person-info">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fas fa-user"></i>
                    <h3>Tonia Deutschler</h3>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-phone-alt"></i>
                    <p>
                      <a href="tel:+494435960000">Tel. 04435 / 9600 - 00</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-10 col-md-6 col-xl-4 mb-4">
              <div class="team-inner">
                <div class="person-image">
                  <img
                    class="rounded-circle border border-light border-3"
                    src="/images/team/viktoria-reil.jpg"
                    alt="Viktoria Reil "
                  />
                </div>

                <div class="person-info">
                  <div class="d-flex align-items-center mb-3">
                    <i class="fas fa-user"></i>
                    <h3>Viktoria Reil</h3>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-suitcase"></i>
                    <p>Auszubildende</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-envelope"></i>
                    <p><a href="mailto:viktoria@scol.de">viktoria@scol.de</a></p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="scol-section bg-light">
        <div class="scol-section-caption">
          <h2>Historie</h2>
        </div>
        <div class="container-small text-block position-relative">
          <div class="row gx-5 mx-0">
            <div class="col-md-6">
              <p>
                <b>....im Winter 1988/1989</b>. Ein paar skibegeisterte, junge
                Leute von der FH Emden organisieren ein günstige Skireise in die
                Alpen. Ein Reisebus mit 36 Insassen startet von Emden über
                Oldenburg und Großenkneten in Richtung Saalbach-Hinterglemm.
                Organisation und Betreuung werden erstmals von Großenkneten aus
                geregelt. Schon im darauffolgenden Winter ist die Nachfrage
                riesig. Es können aber nur max. 60 Personen an der erneuten
                Fahrt teilnehmen.
              </p>
              <p>
                Eine Idee geht ihren Weg.................
                <b>im Winter 1990/1991</b>
                entsteht der Ski Club Oldenburger Land e. V.! Der erste SCOL
                Winter startet. Die Anmeldungen für die 4 geplanten Fahrten
                laufen besser als erwartet. Daher wird schon im ersten Winter
                eine Zusatzfahrt in den Osterferien angeboten. Ziel aller
                Fahrten ist das Skigebiet von Sölden. Mit zunehmender Dauer
                erhöht sich auch der Komfort.
              </p>
              <p>
                Mit dem Gasthof Mühlbacherhof in Mayrhofen/Schwendau erreichen
                <b>1992/1993</b> die Fahrten einen ganz neuen Standard: Ein
                Gasthof gegenüber der Gondelstation, Apres Ski Schirm gleich
                daneben. Es sind keine Skibusfahrten mehr nötig. Dieser Standard
                nimmt weiter zu.
              </p>
              <p>
                In Liftnähe wohnen wir ab dem Winter <b>1994/1995</b> in den
                Orten Sölden, Campitello, Zell am See, Kappl und Mayrhofen. Die
                erste Betreuerfahrt startet mit über 20 Leuten im November nach
                Kaprun. Das Angebot ist auf 27 Fahrten gewachsen. Was als
                "Hobby" begonnen hat ist nun professionelle Reiseveranstaltung
                und findet in der 1996 gegründeten SCOL GmbH ihren Namen.
              </p>
            </div>
            <div class="col-md-6">
              <p>
                Im Winter <b>1997/1998</b> ist "Party on Snow" das Motto der
                Hörerreisen in Zusammenarbeit mit Radio ffn - eine neue
                Dimension von Reisen wird erreicht.
              </p>
              <p>
                Mit über 100 Skireisen zählen wir ab dem Winter
                <b>2001/2002</b> zu den größten Skireiseanbietern im
                Nordwestdeutschen Raum. Zudem starteten wir unsere erste reine
                Jugendtour. Mit über 30 jungen Leuten (zw. 13 und 18 Jahren),
                ging es nach Uderns ins schöne Zillertal.
              </p>
              <p>
                Seit dem Winter <b>2009/2010</b> sind wir nicht mehr nur
                Veranstalter, sondern präsentieren mit dem
                <a href="https://scol-sporthotel.com/" target="_blank"
                  >SCOL Sporthotel Grossglockner"</a
                >
                in Kals das erste durch SCOL geführte Hotel in den Alpen. Auch
                in Zukunft wollen wir unser Konzept der begleiteten
                Gruppenskireisen weiter ausbauen.
              </p>
              <p>
                Im November 2017 haben wir SCOL mit einem weiteren Hotel in
                Österreich erweitert: dem
                <a href="https://scol-hotel-zillertal.at/" target="_blank"
                  >SCOL Sporthotel Zillertal</a
                >
                in Fügen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>





<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
